// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__9gfhk","headerContainer":"Layout_headerContainer__lR8wz","dark":"Layout_dark__V7qJJ","pink":"Layout_pink__doyVr","blue":"Layout_blue__Hnb7G"};